"use client";

import { useEffect } from "react";
import { useSearchParams, useRouter } from "next/navigation";
import { buildBannedPath, isUserBannedAuthError } from "@/lib/ban-details";

/**
 * Client-side redirect for ?error_code=user_banned that previously forced
 * `force-dynamic` on the home page. The real enforcement lives in proxy.ts
 * (supabase auth + isBannedNow); this guard only mirrors the UX redirect
 * without keeping the landing page dynamic for 99.9% of hits.
 */
export function BannedSearchParamGuard() {
  const searchParams = useSearchParams();
  const router = useRouter();

  useEffect(() => {
    const errorCode = searchParams.get("error_code") ?? undefined;
    const errorDescription = searchParams.get("error_description") ?? undefined;
    if (isUserBannedAuthError({ error_code: errorCode, message: errorDescription })) {
      router.replace(buildBannedPath({}));
    }
  }, [searchParams, router]);

  return null;
}
